/** Meta Advanced (APP-548) is listed right after this connector, in its categories. */
export const META_ADVANCED_ANCHOR_SERVICE = "facebook_marketing_airbyte"

const SEARCHABLE_NAME = "meta advanced"

/**
 * Whether the active category gets the Meta Advanced row: it lists Facebook
 * Marketing, and the search (already lower-cased and trimmed) is empty or
 * matches the row's name. SourceItems shows the row to super admins only.
 */
export function shouldShowMetaAdvanced(
  categoryConnectors: { id: string }[],
  searchTerm: string,
): boolean {
  return (
    categoryConnectors.some(({ id }) => id === META_ADVANCED_ANCHOR_SERVICE) &&
    (!searchTerm || SEARCHABLE_NAME.includes(searchTerm))
  )
}
